import { Routes } from '@angular/router';
import { createAuthCanActivate } from './common/auth/auth.guards';

export const APP_ROUTES: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  // Short link redirect handler - must be before wildcard route
  {
    path: 's/:id',
    loadChildren: () =>
      import('./common/shortlink-redirect/shortlink-redirect.module').then((m) => m.ShortlinkRedirectModule),
  },
  {
    path: 'home',
    loadChildren: () => import('./features/home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: 'crisis-support',
    loadChildren: () => import('./features/crisis-support/crisis-support.module').then((m) => m.CrisisSupportModule),
  },
  {
    path: 'stroke-information-resources',
    loadChildren: () =>
      import('./features/stroke-information-resources/stroke-information-resources.module').then(
        (m) => m.StrokeInfoResourcetModule,
      ),
  },
  {
    path: 'about-the-service',
    loadChildren: () =>
      import('./features/about-the-service/about-the-service.module').then((m) => m.AboutProgramModule),
  },
  {
    path: 'about-the-service/faq',
    loadChildren: () => import('./features/about-the-service/faq/faq.module').then((m) => m.FaqModule),
  },
  {
    path: 'access-the-service',
    loadChildren: () =>
      import('./features/access-the-service/access-the-service.module').then((m) => m.GetAccessModule),
  },
  {
    path: 'access-the-service/survivors',
    loadChildren: () =>
      import('./features/access-the-service/survivors/access-the-service-survivors.module').then(
        (m) => m.GetAccessSurvivorsModule,
      ),
  },
  {
    path: 'access-the-service/support-people',
    loadChildren: () =>
      import('./features/access-the-service/carers/access-the-service-carers.module').then(
        (m) => m.GetAccessCarersModule,
      ),
  },
  {
    path: 'access-the-service/health-professionals',
    loadChildren: () =>
      import('./features/access-the-service/health-professionals/access-the-service-health-professionals.module').then(
        (m) => m.GetAccessCliniciansModule,
      ),
  },
  {
    path: 'gp-instruction',
    loadChildren: () => import('./features/gp-instruction/gp-instruction.module').then((m) => m.GPInstructionModule),
  },
  {
    path: 'gp-list',
    loadChildren: () => import('./features/gp-list/gp-list.module').then((m) => m.GPListModule),
  },
  {
    path: 'referral-form',
    loadChildren: () => import('./features/referral-form/referral-form.module').then((m) => m.ReferralFormModule),
  },
  {
    path: 'a11y-statement',
    loadChildren: () => import('./features/a11y-statement/a11y-statement.module').then((m) => m.A11yStatementModule),
  },
  {
    path: 'expired-survey',
    loadChildren: () =>
      import('./features/screening-tools/expired-assessment/expired-assessment.module').then(
        (m) => m.ExpiredAssessmentModule,
      ),
  },
  {
    path: '',
    canActivateChild: [createAuthCanActivate('login')],
    loadChildren: () => import('./features/authorized/authorized.module').then((m) => m.AuthorizedModule),
  },
  {
    path: 'digital-platform-declined',
    loadChildren: () =>
      import('./features/auth/referral-login/invitation-declined/invitation-declined.module').then(
        (m) => m.InvitationDeclinedModule,
      ),
  },
  // Add wildcard route at the end to catch all unknown paths
  { path: '**', redirectTo: 'home' },
];
